/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ChevronDownIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M19.462 27.532 7.468 15.544c-.624-.562-.624-1.498 0-2.123.563-.561 1.5-.561 2.124 0L20.523 24.41l10.932-10.926c.562-.624 1.499-.624 2.123 0a1.47 1.47 0 0 1 0 2.06L21.523 27.532c-.562.624-1.5.624-2.061 0"/>}
        </IconWrapper>);
}
